import { render, staticRenderFns } from "./WeekWorkDays.vue?vue&type=template&id=6efd7478&"
import script from "./WeekWorkDays.vue?vue&type=script&lang=js&"
export * from "./WeekWorkDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports